/**
 * The wordmark glyph: concentric range rings with a sweep arm that rotates once
 * every few seconds. It's the only moving thing in the chrome, so it carries the
 * "this data is live" message without a spinner.
 *
 * The arm rotates anticlockwise so the glow *trails* it, the way a real PPI
 * display works — the phosphor decays behind the beam, it doesn't light up
 * ahead of it. (The wedge is drawn on the clockwise side of the arm, so
 * anticlockwise travel puts it behind.)
 */
export function RadarMark({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 32 32"
      className={className}
      role="img"
      aria-label="Radar"
      fill="none"
      strokeLinecap="round"
    >
      <circle cx="16" cy="16" r="14.5" stroke="var(--color-rule-bright)" strokeWidth="1" />
      <circle
        cx="16"
        cy="16"
        r="9.5"
        stroke="var(--color-rule-bright)"
        strokeWidth="1"
        opacity="0.7"
      />
      <circle
        cx="16"
        cy="16"
        r="4.5"
        stroke="var(--color-rule-bright)"
        strokeWidth="1"
        opacity="0.5"
      />
      <path d="M16 1.5v29M1.5 16h29" stroke="var(--color-rule)" strokeWidth="0.75" />

      <g className="radar-sweep">
        <path d="M16 16 L16 1.5 A14.5 14.5 0 0 1 27 6.5 Z" fill="url(#sweep)" />
        <path d="M16 16 L16 1.5" stroke="var(--color-signal)" strokeWidth="1.25" />
      </g>

      <circle cx="16" cy="16" r="2" fill="var(--color-signal)" />

      <defs>
        <linearGradient id="sweep" x1="16" y1="16" x2="26" y2="4" gradientUnits="userSpaceOnUse">
          <stop stopColor="var(--color-signal)" stopOpacity="0.35" />
          <stop offset="1" stopColor="var(--color-signal)" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
}
